export const parseJsonToString = (value: string, fallback: string = ""): string => {
    try {
        const parsed = JSON.parse(value);
        if (typeof parsed === "object" && parsed !== null) {
            return Object.entries(parsed)
                .filter(([key]) => key !== "id")
                .map(([key, val]) => `${val}`)
                .join(" / ");
        }
        return String(parsed);
    } catch (error) {
        console.error("Failed to parse JSON:", error);
        return fallback;
    }
};